import type { Theme } from '@mui/material';
import { tabClasses } from '@mui/material';

// import type { Components } from '@mui/material/styles';
import { ALPHA_500, ALPHA_700 } from '@/mui/constants/opacity';

export default function MUITab(theme: Theme) /* : Components['MuiTab'] */ {
  const colorList = Object.entries(theme.palette).filter(
    ([key, value]) => key !== 'neutral' && value?.main && value?.contrastText,
  );

  return {
    defaultProps: {
      iconPosition: 'start',
    },
    variants: [
      ...colorList.map(([key, value]) => ({
        props: { color: key },
        style: {
          color: value.main,

          '&.Mui-disabled': {
            color: value.main,
          },

          '&.Mui-selected': {
            color: value.main,
          },
        },
      })),
      {
        props: { size: 'small' },
        style: {
          minHeight: '44px',
          minWidth: '44px',
          fontSize: 12,
          lineHeight: 1.66,

          [`& .${tabClasses.iconWrapper}`]: {
            fontSize: 16,
          },
        },
      },
    ],
    styleOverrides: {
      root: {
        textAlign: 'left',
        textTransform: 'none',
        maxWidth: '360px',
        minWidth: '48px',
        minHeight: '48px',
        padding: '4px 16px 8px 16px',
        fontSize: 14,
        lineHeight: 1.43,
        fontWeight: 400,
        letterSpacing: 0,
        color: theme.palette.text.primary,
        opacity: ALPHA_700,

        [`& .${tabClasses.iconWrapper}`]: {
          fontSize: 18,
        },

        '&.Mui-disabled': {
          color: theme.palette.text.primary,
          opacity: ALPHA_500,
        },

        '&.Mui-selected': {
          color: theme.palette.text.primary,
          opacity: 1,

          '&.Mui-disabled': {
            opacity: ALPHA_500,
          },
        },
      },
    },
    // variants: [],
  };
}
